import type { ModalFactory } from '../../../../vend-ui/types'
import quoteCustomerModalTemplate from './quote-customer-modal.html'

/**
 * Service class for quote customer modals.
 *
 * @class QuoteCustomerModalService
 */
export class QuoteCustomerModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  /**
   * Open the modal responsible for adding customer to quote.
   *
   * @method quoteCustomerModal
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public quoteCustomerModal() {
    return this.Modal({
      controller: 'quoteCustomerModalController',
      controllerAs: '$ctrl',
      template: quoteCustomerModalTemplate,
    })
  }
}
